import React, { useEffect, useState, Fragment } from 'react';
import { Card, Button, Modal } from 'react-bootstrap'
import { CarpetaDigitalComponent } from 'recupero-caso-general';
import BitacoraGestion from '../../bitacora-gestion-recuperador';
import HeaderInfo from './header-info';
import { serviceGetCfgForm } from '../../../api/api-aprobacion-objecion';
import { serviceGetDatosImplicado } from '../../../api/api-recuperacion-cobro';
import { useLocation, useNavigate } from 'react-router-dom';
import { obtenerDatosLlaves} from '../../../store/actions/encargado-cia-action'
import { useDispatch } from 'react-redux';

const FormPrincipal = ({ idCaso, idOrgCaso, idImplicado }) => {
    const dispatch=useDispatch()
    const history = useNavigate();
    const { state } = useLocation();
    const queryState=JSON.parse(localStorage.getItem('filtrosRecuperoCias'));
    const [cfg_form, setCfg_form] = useState(null);
    const [implicado, setImplicado] = useState(null);

    const [showCarpeta, setShowCarpeta] = useState(false);
    const [showBitacora, setShowBitacora] = useState(false);
    const handleCloseCarpeta = () => setShowCarpeta(false);
    const handleCloseBitacora = () => setShowBitacora(false);

    useEffect(() => {     
        dispatch(obtenerDatosLlaves({"idCaso":idCaso,"idImplicado":idImplicado,"idOrgCaso":idOrgCaso}));    
    }, [dispatch])

    useEffect(() => {
        getCfgForm();
        getDatosImplicado();
    }, [])

    const getCfgForm = async () => {
        const query = Buffer.from(JSON.stringify({ rutcia: idOrgCaso, idform: 60 })).toString('base64');
        const response = await serviceGetCfgForm(query);
        
        setCfg_form(response);
    }

    const getDatosImplicado = async () => {
        const query = Buffer.from(JSON.stringify({ idCaso: idCaso, idImplicado: idImplicado })).toString('base64');
        const response = await serviceGetDatosImplicado(query);

        setImplicado(response && response.length > 0 ? response[0] : null);
    }

    const goAreaTrabajo = () => { history('/area-trabajo-recupero-companias', { state: { queryState } }) };

    return (
        <Fragment>
            <Card className='mt-2 mb-2'>
                <Card.Header as='h6' style={{ backgroundColor: "#4F517A", color: '#FFFFFF' }}>
                    {cfg_form && cfg_form["legalizapagotercero-title"]}
                    {` (${implicado?.IdImplicado ?? 'SIN INFORMACION'}: ${implicado?.NombreImplicado ?? 'SIN INFORMACION'} - ${implicado?.Patente ?? 'SIN INFORMACION'})`}

                </Card.Header>

                <Card.Body>
                    <HeaderInfo
                        idCaso={idCaso}
                        idOrgCaso={idOrgCaso}
                        cfg_form={cfg_form}
                        implicado={implicado}
                    />
                </Card.Body>

                <Card.Footer style={{ display: 'flex', justifyContent: 'right' }}>
                    <Button className='m-2' variant='outline-info' onClick={goAreaTrabajo}>
                        {cfg_form && cfg_form["legalizapagotercero-btn-volver"]}
                    </Button>
                    <Button className='m-2' variant='carpeta' onClick={() => setShowCarpeta(true)}>
                        {cfg_form && cfg_form["legalizapagotercero-btn-carpeta"]}
                    </Button>
                    <Button className='m-2' variant='bitacora' onClick={() => setShowBitacora(true)}>
                        {cfg_form && cfg_form["legalizapagotercero-btn-bitacora"]}
                    </Button>
                </Card.Footer>
            </Card>

            <BitacoraGestion
                handleCloseBitacora={handleCloseBitacora}
                showBitacora={showBitacora}
            />

            <Modal show={showCarpeta} onHide={handleCloseCarpeta} size="xl">
                <CarpetaDigitalComponent
                    handleClose={handleCloseCarpeta}
                    idCaso={idCaso}
                    idOrganizacionCaso={idOrgCaso}
                    idImplicado={idImplicado}
                    prototipo={2}
                />
            </Modal>

            <style type='text/css'>
                {`
                    .is_required:after {
                        content: "*";
                        margin-left: 2px;
                        color: #000;
                        font-weight: 500;
                        font-size: 12pt;
                    }
                    .label {
                        font-weight: bold;
                        font-size: 14px;
                    }
                    .btn-carpeta {
                        background-color: #D59B49;
                        color: #FFFFFF;
                        width: 140px;
                    }
                    .btn-carpeta:hover {
                        background-color:#e1b97f;
                        color: #FFFFFF;
                    }
                    .btn-bitacora {
                        background-color: #55B2CE;
                        color: #FFFFFF;
                        width: 140px;
                    }
                    .btn-bitacora:hover{
                        background-color: #87c9dc;
                        color: #FFFFFF;
                    } 
                    .btn-carta {
                        background-color:  #2E6EA5;
                        color: #FFFFFF;
                        width: 140px;     
                        padding:6px 0px 6px 0px;
                    }
                    .btn-carta:hover{
                        background-color:  #5b9ad1;
                        color: #FFFFFF;
                    }
                    .btn-actualizar {
                        background-color: #C14B49;
                        color: #FFFFFF;
                        width: 160px;
                    }
                    .btn-actualizar:hover{
                        background-color: #d3807f;
                        color: #FFFFFF;
                    }
                    .btn-volver {
                        color: #66CCCC;
                        border: 1px solid #C00
                        width: 140px;
                    }
                    .btn-tamano{
                        padding: 1rem 1.5rem;
                        font-size: 1.5rem;
                    }
                `}
            </style>
        </Fragment>
    )
}

export default FormPrincipal;